import * as React from 'react'
import { Sidebar } from '../../BulkActionsSidebar'
import {
  BulkUpdateExpectedClosingDateFormModel,
  SubmitCallback,
  ValidationCallback,
} from './typings'
import { FormFields } from './FormFields'
import { useFormActions } from './hooks/useFormActions'
import { FormikErrors } from 'formik'

const initialValues: BulkUpdateExpectedClosingDateFormModel = {
  expectedClosingDate: new Date(),
}

type Props = {
  validateRows: ValidationCallback
  onSubmit: SubmitCallback
  setUpdateExpected?: React.Dispatch<React.SetStateAction<boolean>>
}

export const BulkUpdateExpectedClosingDateForm: React.FC<Props> = (props) => {
  const { onSubmit, validateRows, setUpdateExpected } = props

  const submitHandler = useFormActions(onSubmit)

  const validate = React.useCallback(
    (values: BulkUpdateExpectedClosingDateFormModel) => {
      const errors: FormikErrors<BulkUpdateExpectedClosingDateFormModel> = {}

      if (values.expectedClosingDate === null)
        errors.expectedClosingDate = 'Required'

      return errors
    },
    [],
  )

  return (
    <Sidebar
      title="Update Expected Closing Date"
      initialValues={initialValues}
      onSubmit={submitHandler}
      validate={validate}
      validateOnBlur={false}
    >
      <FormFields
        validateRows={validateRows}
        setUpdateExpected={setUpdateExpected}
      />
    </Sidebar>
  )
}
BulkUpdateExpectedClosingDateForm.displayName =
  'BulkUpdateExpectedClosingDateForm'
